// The API's public answers from the site's own edge cache (functions/edge/[[path]].js: Cloudflare keeps a copy, so
// a visitor doesn't reach the API's Raspberry Pi): the RegSO shapes and statistics, listvy's searches, listings,
// price curves, travel times and kartvy's compact listings (edgeSources, for compactListingsCore.js's worker). Where
// there's no edge (a dev server, a build served locally, which answer with the app's HTML) or it fails, straight
// from the API. The browser caches either way where the API says so (ETag + max-age).

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.xn--omrdeskollen-vcb.nu';

let edgeWorks = typeof window !== 'undefined'
    && process.env.NODE_ENV === 'production'
    && !process.env.REACT_APP_API_BASE_URL;

// fetch() for an API URL, through the edge when there is one: the edge's own answer (a copy, or the API's answer
// passed through, a 400 or 404 included) when it gave one, else the API itself. An answer without the edge's
// x-edge-cache header is the site's HTML (no edge here): the API from then on, this page load.
export const apiFetch = async (url, init) => {
    const href = String(url);
    if (edgeWorks && href.startsWith(`${API_BASE}/`)) {
        try {
            const response = await fetch(`/edge/${href.slice(API_BASE.length + 1)}`, init);
            const state = response.headers.get('x-edge-cache');
            if (state && state !== 'ERROR' && state !== 'NOT-CACHED') return response;
            if (!state) edgeWorks = false;
        } catch (error) {
            if (error?.name === 'AbortError') throw error;
        }
    }
    return fetch(href, init);
};

const loadPayload = async (name) => {
    const response = await apiFetch(`${API_BASE}/${name}`);
    if (!response.ok) throw new Error(`${name}: ${response.status}`);
    return response.json();
};

export const loadOverlay = () => loadPayload('getoverlay');
export const loadAreaData = () => loadPayload('getdata');

// The URLs to fetch an API endpoint from, in order: the site's edge copy first when there is one, then the API.
// Absolute, since a Web Worker resolves a relative URL against its own script.
export const edgeSources = (apiUrl) => {
    const url = String(apiUrl || '');
    if (!edgeWorks || !url.startsWith(`${API_BASE}/`)) return [url];
    return [`${window.location.origin}/edge/${url.slice(API_BASE.length + 1)}`, url];
};
